import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  return (
    <nav className="bg-white/90 backdrop-blur-md border-b border-gray-100 sticky top-0 z-50 transition-all duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center">
            <a href="/" className="flex items-center space-x-2 group">
              <img src="/logo.png" alt="Logo" className="h-8 w-8 transition-transform duration-300 group-hover:scale-110" />
              <span className="text-xl font-bold font-serif bg-gradient-to-r from-blue-600 to-blue-800 bg-clip-text text-transparent">
                RemoveBackground<span className='sr-only'>.online</span>
              </span>
            </a>
            
            {/* Desktop Navigation */}
            <div className="hidden md:flex ml-10 space-x-8">
              {[
                { name: 'About', href: '/about', isAnchor: false },
                { name: 'Contact', href: '/contact', isAnchor: false },
              ].map((item) => (
                item.isAnchor ? (
                  <a
                    key={item.name}
                    href={item.href}
                    onClick={(e) => {
                      e.preventDefault();
                      const element = document.querySelector(item.href);
                      if (element) {
                        const offset = 80;
                        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
                        window.scrollTo({
                          top: elementPosition - offset,
                          behavior: 'smooth'
                        });
                      }
                    }}
                    className="text-gray-600 hover:text-blue-600 transition-colors px-3 py-2 text-sm font-medium relative group cursor-pointer"
                  >
                    {item.name}
                    <span className="absolute bottom-0 left-0 w-full h-0.5 bg-blue-600 transform scale-x-0 transition-transform duration-300 group-hover:scale-x-100" />
                  </a>
                ) : (
                  <Link
                    key={item.name}
                    to={item.href}
                    className="text-gray-600 hover:text-blue-600 transition-colors px-3 py-2 text-sm font-medium relative group cursor-pointer"
                  >
                    {item.name}
                    <span className="absolute bottom-0 left-0 w-full h-0.5 bg-blue-600 transform scale-x-0 transition-transform duration-300 group-hover:scale-x-100" />
                  </Link>
                ))
              )}
            </div>
          </div>

          {/* CTA Button */}
          <div className="flex items-center space-x-4">
            <a
              href="/#bulk-removal"
              className="inline-flex items-center px-6 py-2.5 border border-transparent text-sm font-medium rounded-full 
                            text-white bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 
                            transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
            >
              Try Removal
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;